<template>
  <div class="optimization-report">
    <h3 class="mt-4">After optimization</h3>
    <OptimizationTable header-color="dark" class="table-report bg-dark-green-title">
      <tr v-for="(report, index) in reportData.optimization" :key="'after_report_' + index">
        <td>{{ ucFirst(report.carrier) }}</td>
        <td>{{ ucFirst(report.productName) }}</td>
        <td>{{ contract }}</td>
        <td>{{ report.itemsCount }}</td>
        <td>{{ itemsCount }} pc</td>
        <td>{{ report.averageWeight }} g</td>
        <td>{{ formattedPrice(report.averagePrice) }}</td>
        <td>{{ formattedPrice(report.totalPrice) }}</td>
      </tr>

      <tr class="footer-cells">
        <td colspan="3" class="fw-400">Total</td>
        <td class="fw-400">
          {{ productManagement }}
        </td>
        <td colspan="3" class="fw-400">Average Saving per Package</td>
        <td :class="{ 'fw-400': true, negative: reportData.percentSaved < 0 }">
          {{ formattedPrice(reportData.averageSavingsPerPackage) }}
        </td>
      </tr>

      <tr class="footer-cells total-savings">
        <td colspan="4" class="border-0" />
        <td colspan="3" class="align-middle fw-400">Total Savings</td>
        <td :class="{ negative: reportData.percentSaved < 0 }">
          <div class="d-flex align-items-center fw-400 ws-pre-line">
            {{ formattedPrice(reportData.totalSavings) }}
            <span v-if="reportData.percentSaved > 0" class="ml-2 bg-green fw-400 total-saved">
              {{ reportData.percentSaved }}% Saved
            </span>
          </div>
        </td>
      </tr>
      <tr class="footer-cells total-sum">
        <td colspan="4" class="border-0" />
        <td colspan="3" class="align-middle fw-400">Total Cost</td>
        <td class="color-black fw-400">{{ formattedPrice(reportData.optimizationCost) }}</td>
      </tr>
    </OptimizationTable>
  </div>
</template>

<script lang="ts">
import type { OptimisationReport } from '@/types/Models/OptimisationReport'
import { defineComponent, computed, type ComputedRef } from 'vue'
import { formattedPrice, ucFirst } from '@/services/Helpers'
import { useAssignmentSummaryStore } from '@/store/assignmentSummary'
import { useOptimizationReportStore } from '@/store/optimizationReport'
import OptimizationTable from '@/views/Components/Elements/Table/OptimizationTable.vue'

export default defineComponent({
  name: 'AfterOptimizationTable',
  components: { OptimizationTable },
  setup() {
    const assignmentSummaryStore = useAssignmentSummaryStore()
    const optimizationReportStore = useOptimizationReportStore()

    const reportData: ComputedRef<OptimisationReport> = computed(() => optimizationReportStore.report)
    const assignment: ComputedRef = computed(() => assignmentSummaryStore.assignment)
    const contract: ComputedRef<string> = computed(() =>
      assignment.value.contractParty ? assignment.value.contractParty : 'MailWorld',
    )
    const itemsCount: ComputedRef<number> = computed(() => assignment.value.itemsCount)
    const productManagement: ComputedRef = computed(() => {
      let sum = 0
      reportData.value.optimization.forEach((el: any) => {
        sum += el.itemsCount
      })
      return sum
    })
    const totalSavings: ComputedRef<string> = computed(() => reportData.value.totalSavings.trim())

    return {
      reportData,
      contract,
      itemsCount,
      productManagement,
      totalSavings,
      ucFirst,
      formattedPrice,
    }
  },
})
</script>
